import { render, staticRenderFns } from "./order-return-form-modal.component.vue?vue&type=template&id=242e4788&"
import script from "./order-return-form-modal.component.vue?vue&type=script&lang=ts&"
export * from "./order-return-form-modal.component.vue?vue&type=script&lang=ts&"
import style0 from "./order-return-form-modal.component.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "order-return-form-modal.component.vue"
export default component.exports